import React, { Component } from 'react';
import Flexbox from '../components/misc/Flexbox'; 
import SidebarKalender from '../components/SidebarKalender'; 
import {createMarkup} from './Factory';
import {UISref} from 'ui-router-react'; 

class Sidebar extends Component {
	constructor(props) {
		super(props);
		this.handleClick = this.handleClick.bind(this);	
	}
	handleClick(){
		let {title,price} = this.props.publication;
		this.props.handleClick(title,price);
	}
	render(){
		const { 
			publication_left,publication_right,press_left,press_right,press_text,press_link_label,
			booklet_left,booklet_right,booklet_text,booklet_label,booklet_file,booklet_file_label,programm_left,programm_right,
			publication,programm_one,programm_two,programm_three,programm_four,programm_five,
			additional_left,additional_right,additional_text,additional_label,additional_file,
			external_left,external_right,external_link,external_link_label,additional_file_label
		} =  this.props;
		const { label_bestellen,label_vergriffen,label_clock } = this.props.staticData;
		let divStyle = {
				backgroundImage: 'url(' + publication.image + ')',
				backgroundSize: 'contain',
				maxWidth: '100%',
		}	
		return(			
			<section className="col-md-4 sidebar article-list">
				{(publication_left)? 
				<div className="pubs-list sidebar-block">
                    <Flexbox left={publication_left} right={publication_right} />
                    <article className="pubs-item">
                        <div title={publication.image_title} className="fixed-ht-img thumb" style={divStyle}>
							<img src={publication.image} alt={publication.image_alt} title={publication.image_title} />
                        </div>
                        <div className="details">
                            <p dangerouslySetInnerHTML={createMarkup(publication.text)}></p>
                            <div className="price">
                                {publication.price}<br/>
                                {(publication.active!=="0") ?
								<a onClick={this.handleClick} className="open-overlay">- {label_bestellen}</a>
								: <a className="open-overlay no-hover">{label_vergriffen}</a>
								}
                            </div>
                        </div>
                    </article>
                </div> 
				:null
				}
				{(press_text)?
				<div className="press-material txt-block sidebar-block">
                    <Flexbox left={press_left} right={press_right} />
                    
                    <div className="press-item">                       
                        <p dangerouslySetInnerHTML={createMarkup(press_text)}></p>
                        <div className="action">
                            <UISref to="root.presse.presselogin">
								<a target="_blank">{press_link_label}</a>
							</UISref>
                        </div>
                    </div>                    
                </div>
				:null
				}
				{
				(booklet_left)?
				<div className="download txt-block sidebar-block">
                    <Flexbox left={booklet_left} right={booklet_right} />
                    
                    <div className="press-item">                       
                        <p dangerouslySetInnerHTML={createMarkup(booklet_text)}></p>
                        <div className="action">
						{
							booklet_file.map((data,i)=>
								<div key={i}><a target="_blank" href={data}>{booklet_file_label[i]}</a></div>
							)
                        }
						</div>
                    </div>                    
                </div>
				:null
				}
				{
				(additional_left)?
				<div className="download txt-block sidebar-block">
                    <Flexbox left={additional_left} right={additional_right} />
                    
                    <div className="press-item">                       
                        <p dangerouslySetInnerHTML={createMarkup(additional_text)}></p>
                        <div className="action">
						{
							additional_file.map((data,i)=>
								<div key={i}><a target="_blank" href={data}>{additional_file_label[i]}</a></div>
							)
						}
                        </div>
                    </div>                    
                </div>
				:null
				}
				{
				(external_left)?
				<div className="download txt-block sidebar-block">
                    <Flexbox left={external_left} right={external_right} />
                    
                    <div className="press-item">                       
                        <div className="action">
						{
							external_link_label.map((data,i)=>
								<div key={i}><a target="_blank" href={external_link[i]}>{data}</a></div>
							)
						}
                        </div>
                    </div>                    
                </div>
				:null
				}
				{
					(programm_one)?
						<div className="calendar-block sidebar-block">
							<Flexbox left={programm_left} right={programm_right} />
							<section className="events-calendar mini-calendar">
								<SidebarKalender key={1} clock={label_clock} {...programm_one} />
								<SidebarKalender key={2} clock={label_clock} {...programm_two} />
								<SidebarKalender key={3} clock={label_clock} {...programm_three} />
								<SidebarKalender key={4} clock={label_clock} {...programm_four} />
								<SidebarKalender key={5} clock={label_clock} {...programm_five} />
							</section> 										  
						</div>
					:null
				}
				
			</section>
		)
	}	
}
export default Sidebar;


// WEBPACK FOOTER //
// ./src/components/Sidebar.js